import { defineComponent as _defineComponent } from 'vue'
import { type StyleValue, computed } from 'vue'
import type {
  Alignment,
  MiddlewareData,
  Placement,
  Side,
} from '@floating-ui/vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingArrow',
  props: {
    context: null,
    size: { default: 8 },
    staticOffset: null
  },
  setup(__props: any) {

const props = __props as { context: {
      placement: Placement
      middlewareData: MiddlewareData
    }, size: number, staticOffset: number | null | undefined };



// Arrow positioning with static side calculation
const arrowStyles = computed(() => {
  const {
    placement,
    middlewareData: { arrow, shift },
  } = props.context

  if (!arrow) {
    return {}
  }

  const [side, alignment] = placement.split('-') as [Side, Alignment]
  const isVerticalSide = side === 'top' || side === 'bottom'

  let computedStaticOffset = props.staticOffset
  if ((isVerticalSide && shift?.x) || (!isVerticalSide && shift?.y)) {
    computedStaticOffset = null
  }

  const yOffsetProp =
    computedStaticOffset && alignment === 'end' ? 'bottom' : 'top'
  const xOffsetProp =
    computedStaticOffset && alignment === 'end' ? 'right' : 'left'

  const arrowX = arrow?.x != null ? computedStaticOffset || arrow.x : ''
  const arrowY = arrow?.y != null ? computedStaticOffset || arrow.y : ''

  const rotation = {
    top: 'rotate(-135deg)',
    left: 'rotate(135deg)',
    bottom: 'rotate(45deg)',
    right: 'rotate(-45deg)',
  }[side]

  const styles: StyleValue = {
    height: `${props.size}px`,
    width: `${props.size}px`,
    [xOffsetProp]: `${arrowX}px`,
    [yOffsetProp]: `${arrowY}px`,
    [side]: `calc(100% - ${props.size / 2}px)`,
    transform: rotation,
  }

  return styles
})

return { __sfc: true,props, arrowStyles }
}

})